import { IReparcelingSimulation } from 'modules/customer/domain/entities';

export interface IVectisReparcelingSimulation {
  valorParcela: number;
  numeroParcelas: number;
  descricaoParcelamento: string;
}

export class ReparcelingSimulation implements IReparcelingSimulation {
  public number: IReparcelingSimulation['number'];
  public value: IReparcelingSimulation['value'];
  public description: IReparcelingSimulation['description'];

  constructor({
    descricaoParcelamento,
    numeroParcelas,
    valorParcela,
  }: IVectisReparcelingSimulation) {
    this.number = numeroParcelas;
    this.value = valorParcela;
    this.description = descricaoParcelamento;
  }
}
